<script>
  import { tick } from 'svelte';
  import { filter as fuzzy } from 'fuzzyjs';
  import { prop } from 'ramda';
  import Checkbox from '@commercebear/components/Checkbox';
  import Dropdown from '@commercebear/components/Dropdown';
  import KeyboardList from '@commercebear/components/KeyboardList';
  import Rule from '@commercebear/components/Rule';
  import TextInput from '@commercebear/components/TextInput';
  import { useIsAdmin } from '$providers/IsAdmin/IsAdmin.svelte';
  import Auth from '$util/auth';
  import { getStores } from '$app/stores';
  import OrganizationPickerItem from './OrganizationPickerItem.svelte';

  const isAdmin = useIsAdmin();
  const { page } = getStores();

  export let anchor;
  export let name;

  let showDropdown;
  let focusInput;
  export async function show() {
    showDropdown();
    await tick();
    focusInput();
  }

  export let currentOrganization;
  export let allOrganizations;

  let searchText = '';
  let displayDeactivatedOrgs;

  async function pickOrganization(organizationId) {
    await Auth.changeOrganization(organizationId);
    const destination = $page.url.pathname.replace(/^\/organizations\/[^/]+\//, `/organizations/${organizationId}/`);
    window.location = destination;
  }

  $: relevantOrganizations = allOrganizations
    .filter((item) => item.id !== currentOrganization.id && (displayDeactivatedOrgs || item.active))
    .filter(fuzzy(searchText, { iterator: prop('name') }));
</script>

<Dropdown testid='organization-picker' gravity='top right' {anchor} {name} bind:show={showDropdown} on:dismiss>
  <div class='search-area'>
    <TextInput name='organization-picker-search' placeholder='Search by Organization Name' leftIcon='search' bind:value={searchText} autocomplete='off' bind:focus={focusInput} testid='org-picker-search'/>
    {#if $isAdmin}
      <div class='checkbox'>
        <Checkbox name='display-deactivated-organizations' bind:checked={displayDeactivatedOrgs}>
          Display Deactivated Organizations
        </Checkbox>
      </div>
    {/if}
  </div>
  {#if $isAdmin}
    <div class='rule'>
      <Rule/>
    </div>
  {/if}

  <KeyboardList let:list>
    <div class='list'>
      <OrganizationPickerItem {list} org={currentOrganization} current testid='first-org-picker-item'/>
      {#each relevantOrganizations as org (org.id)}
        <OrganizationPickerItem {list} {org} on:click={() => pickOrganization(org.id)} deactivated={!org.active} testid='org-picker-item' />
      {/each}
    </div>
  </KeyboardList>
</Dropdown>

<style>
  .list {
    max-height: 60vh;
    overflow: scroll;
  }

  .search-area {
    padding: var(--spacing--m);
    background-color: var(--color--default--background);
    z-index: 1;
    position: static;
  }

  .checkbox {
    margin-top: var(--spacing--m);
    color: var(--color--default--text);
  }
</style>
